import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter
} from '@reduxjs/toolkit'
import { envAwarePost } from '../util/util'


const apiStatusSlice = createSlice({
    name: 'apiStatusSlice',
    initialState: {
        message: '',
        status: 'idle',
        item: "",
        operation: ""
    },
    reducers: {
        successStatus: (state, action) => {
            const {success,item,operation,message} = action.payload

            if (success) {
                state.status = "success";
                state.item = item;
                state.operation = operation;
                state.message = message
            } else {
                state.status = "fail"
                state.item = item;
                state.operation = operation;
                state.message = message;
            }
        },
        statusFalse: (state, action) => {
            state.status = "idle";
        },

    },
})

export const { successStatus, statusFalse } = apiStatusSlice.actions

export default apiStatusSlice.reducer